<script setup lang="ts">
import { PublicSellerFabricsQuery } from '@gql/PublicSellerFabricsQuery'

const t2 = useT2({
  Fabrics: 'Audiniai',
})

const { seller, sellerId } = useSeller('server')
const { ui } = useApolloWrap2<gen.PublicSellerFabricsQuery, gen.PublicSellerFabricsQueryVariables>(PublicSellerFabricsQuery)({
  vars() {
    const id = sellerId.value
    return id ? { sellerId: id } : undefined
  },
  ui: (i) => helpers.arr(i?.publicSellerFabrics),
})

// <!-- <DevLink to="https://www.intimissimi.com/lt/product-guide-textiles.html"></DevLink>
//     <DevLink to="https://www.meandem.com/fabric-lab"></DevLink> -->
</script>

<template>
  <AppMenu :title="t2('Fabrics')">
    <template #content>
      <DocumentUi :document-id="seller?.doc?.fabrics?._id" />
    </template>

    <InfoBoxes
      v-slot="{ item }"
      :items="ui"
      :ui="
        (i, index) => ({
          key: index,
          title: i.title.value,
          description: i.description.value,
          img: i.image,
          hasContent: !!i?._care?.message?.value || !!i?._care?._careIcons?.length,
        })
      "
    >
      <div v-if="item?._care?.message?.value" class="_short _fs09">{{ item?._care?.message?.value }}</div>
      <InfoCare :icons="item?._care?._careIcons" />
    </InfoBoxes>
  </AppMenu>
</template>
